const PageModelLocal = {
  retirementplannercon: {
    ':type': 'workplace-spa/components/retirementplannercontainer',
    linkLabel: 'Information and Assumptions',
    onTrack:
      '\u003Cp\u003EBased on our estimates, you appear to be \u003Cspan class="on-track"\u003Eon track\u003C/span\u003E to have enough retirement income\u003C/p\u003E\r\n\u003Cp\u003E \u003C/p\u003E\r\n',
    textIsRich: ['true', 'true'],
    title: 'Retirement Income Planner',
    offTrack:
      'Based on our estimates, you appear to be \u003Cspan class="off-track"\u003Eoff track\u003C/span\u003E to have enough retirement income.',
  },
  strategycontainer: {
    ':type': 'workplace-spa/components/strategycontainer',
    title: '',
  },
  educationcontainer: {
    ':type': 'workplace-spa/components/educationcontainer',
  },
  xfscripts: {
    ':type': 'workplace-spa/components/xfscriptscontainer',
  },
};

export default PageModelLocal;
